import {FeedbackSettings} from 'frontend/utils/feedback_settings';

/**
 * GPT-T-specific event categories.
 *
 * The document that describes all the tracking events can be found in the bug
 * http://b/287259940
 */
export enum EventCategoryType {
  ASSET_DETAILS = 'Asset details',
  DATA_DELETE = 'Data delete',
  DATA_FILTERING = 'Data filtering',
  FORMS = 'Forms',
  PAGE_LOAD = 'Page load',
  SIMULATION_RESULTS = 'Simulation results',
  TABLE_SORT_ORDER_CHANGE = 'Table sort order change',
}

/**
 * GPT-T-specific event types.
 *
 * The document that describes all the tracking events can be found in the bug
 * http://b/287259940
 */
export enum EventActionType {
  ADD_SCENARIO = 'add_scenario',
  ALTERNATIVE_CREATED = 'alternative_created',
  CHANGE_CREATED = 'change_created',
  CONGESTION_FILTER_APPLIED = 'congestion_filter_applied',
  DELETE_ALTERNATIVE = 'delete_alternative',
  DELETE_SCENARIO = 'delete_scenario',
  DELETE_STUDY = 'delete_study',
  LINE_VIEW_RESULTS = 'line_view_results',
  LOADING_TIME = 'loading_time',
  LOGS_DOWNLOAD = 'log_download',
  MAP_FILTERED = 'map_filtered',
  MAP_SELECT_ASSET = 'map_select_asset',
  MODEL_LIBRARY = 'view_model_library',
  MODEL_MAP_VIEW = 'map_view',
  MODEL_SEARCH = 'model_search',
  MODEL_TABLE_VIEW = 'table_view',
  MODEL_VIEW = 'model_view',
  PROJECT_ADDED = 'project_added',
  RESULTS_CHART_FILTERED = 'results_chart_filtered',
  RESULTS_MAP_SCROLL = 'results_map_scroll',
  SCENARIO_CREATED = 'scenario_created',
  SCENARIO_LIBRARY = 'view_scenario_library',
  SIMULATION_RUN = 'simulation_run',
  SORT_MODELS = 'sort_models',
  SORT_PROJECTS = 'sort_projects',
  SORT_SCENARIOS = 'sort_scenarios',
  SORT_STUDIES = 'sort_studies',
  STUDY_CREATED = 'study_created',
  STUDY_LIBRARY = 'view_study_library',
  VERSION_CREATED = 'version_created',
  VIEW_ADD_SCENARIO = 'view_add_scenario',
  VIEW_ALTERNATIVE_DETAILS = 'view_alternative_details',
  VIEW_ALTERNATIVE_LOGS = 'view_alternative_logs',
  VIEW_ALTERNATIVE_RESULTS = 'view_alternative_results',
  VIEW_ASSET_PROPERTIES = 'view_asset_properties',
  VIEW_BASELINE_DETAILS = 'view_baseline_details',
  VIEW_BASELINE_LOGS = 'view_baseline_logs',
  VIEW_BASELINE_RESULTS = 'view_baseline_results',
  VIEW_NEW_SCENARIO = 'view_new_scenario',
  VIEW_NEW_STUDY = 'view_new_study',
  VIEW_SCENARIO_FUEL = 'view_scenario_fuel',
  VIEW_SCENARIO_GEN = 'view_scenario_gen',
  VIEW_SCENARIO_LOAD = 'view_scenario_load',
  VIEW_SELECT_MODEL = 'view_select_model',
  VIEW_STUDY_PROJECTS = 'view_study_projects',
  VIEW_STUDY_SCENARIOS = 'view_study_scenarios',
  VIEW_STUDY_NPV = 'view_study_net_present_value',
  VIEW_UPLOAD_FUEL = 'view_upload_fuel',
  VIEW_UPLOAD_GEN = 'view_upload_gen',
  VIEW_UPLOAD_LOAD = 'view_upload_load',
}

export enum PageTitles {
  CREATE_ALTERNATIVE = 'Create alternative',
  CREATE_PROJECT = 'Create project',
  GRID_REVIEWER = 'Grid Reviewer',
  MODEL_VIEW = 'Model view',
  NEW_SCENARIO = 'Create a new scenario',
  NEW_STUDY = 'Create a new study',
  MODEL_MANAGEMENT = 'Model management',
  MODEL_EDIT_DETAILS = 'Model edit details',
  PLANNING = 'Planning',
  PROJECT_DETAILS = 'Projects details',
  SCENARIO_DETAILS = 'Scenario details',
  SCENARIO_EDIT = 'Edit scenario',
  SIMULATION = 'Simulation',
  STUDY_DETAILS = 'Study details',
  STUDY_EDIT = 'Edit study',
}

export interface UserFeedback {
  api: {
    startFeedback: (config: FeedbackSettings) => void;
  };
}
